import React from 'react'
import { NavLink } from 'react-router-dom';
import { NavBarLink } from './NavBarLink';
import logo from '../../images/RH-Vectorised-Logo-white.svg'

interface props {
    links : NavBarLink[]
}

const DesktopNavBar = ({links} : props) => {
    return (
        <nav className="bg-blue-900 h-16">
            <ul className="flex items-center h-full">
                <li><img src={logo} className='w-12 m-2 ml-4'/></li>
                {links.map((link, index) => { 
                    return <li key={`${link.title}_${index}_item`}><NavLink key={`${link.title}_${index}`} to={link.href} className={"font font-lora font-semibold"}>{link.title}</NavLink></li>
                })}
            </ul>
        </nav>
    )
};

export default DesktopNavBar;